
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { DatePipe} from '@angular/common';
import { Observable } from 'rxjs/internal/Observable';
import { Router } from '@angular/router';
import { environment } from '../environments/environment';
@Injectable({
  providedIn: "root",
})
export class CommonService {
  // apiURL: string = "http://localhost:3000/api";
  apiURL: string = environment.apiURL;
  httpOptions = {
    headers: new HttpHeaders({
      "Access-Control-Allow-Origin": "*",
      "Access-Control-Allow-Methods": "GET, POST, OPTIONS, PUT, PATCH, DELETE",
      "Access-Control-Allow-Headers":
        "Access-Control-Allow-Headers, Origin,Accept, X-Requested-With, Content-Type, Access-Control-Request-Method, Access-Control-Request-Headers,X-Access-Token,XKey,Authorization",
    }),
  };
  /* httpOptions = {
    headers: new HttpHeaders({
      "content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      "Access-Control-Allow-Origin" : '*',
      'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, PATCH, DELETE',
      'Access-Control-Allow-Headers': 'Access-Control-Allow-Headers, Origin,Accept, X-Requested-With, Content-Type, Access-Control-Request-Method, Access-Control-Request-Headers,X-Access-Token,XKey,Authorization'

    })
  };*/

  constructor(private httpClient: HttpClient, private router: Router) { }

  async postApi(Api_url, data: any): Promise<Observable<any>> {
    return this.httpClient.post(this.apiURL + Api_url, data);
  }
  async getApi(Api_url): Promise<Observable<any>> {
    return this.httpClient.get(this.apiURL + Api_url);
  }
  async deleteApi(Api_url): Promise<Observable<any>> {
    return this.httpClient.delete(this.apiURL + Api_url);
  }
  async putApi(Api_url, data: any): Promise<Observable<any>> {
    return this.httpClient.put(this.apiURL + Api_url, data);
  }
  getToken() {
    return localStorage.getItem("token");
  }
  loggedIn() {
    return !!localStorage.getItem("token");
  }
  logoutUser() {
    localStorage.removeItem("token");
    this.router.navigate(["/login"]);
  }
  Restrictmodule() {
    console.log(!!localStorage.getItem("hide"));
    return !!localStorage.getItem("hide");
  }
}
